export default __webpack_public_path__ + "static/media/ahsen.8ce3c842.png";